import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OrderRowPop from "./OrderRowPop";
import formatDate from "../../../utils/FormatDate";
import OrderExpandRow from "./OrderExpandRow";
import OrderLocationPop from "./OrderLocationPop";

const OrderRow = ({ order }) => {
  // const authUser = JSON.parse(localStorage.getItem("user"));
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  // for pop
  const [expandPopOrderId, setExpandPopOrderId] = useState(null);
  const [expandLocationPop, setExpandLocationPop] = useState(null);
  const [status, setStatus] = useState(0);

  // using use effect to set order Status
  useEffect(() => {
    setStatus(order.status);
  }, [order]);

  // Function to toggle the expandable row for a specific order
  const toggleExpand = (orderId) => {
    if (expandedOrderId === orderId) {
      setExpandedOrderId(null); // Collapse the row if it's already expanded
    } else {
      setExpandedOrderId(orderId);
    }
  };
  const toggleExpandPop = (orderId) => {
    if (expandPopOrderId === orderId) {
      setExpandPopOrderId(null); // Collapse the row if it's already expanded
    } else {
      setExpandPopOrderId(orderId);
    }
  };

  // for toggle Location Exapand
  const toggleLocationPop = (orderId) => {
    if (expandLocationPop === orderId) {
      setExpandLocationPop(null);
    } else {
      setExpandLocationPop(orderId);
    }
  };
  return (
    <>
      <tr className=" border-b">
        <td className="px-6 py-4 text-center text-gray-900">
          <button
            className="text-blue-500 hover:text-blue-700"
            onClick={() => {
              toggleExpand(order.orderId);
            }}
          >
            {expandedOrderId === order.orderId ? "إخفاء" : "عرض التفاصيل"}
          </button>
        </td>
        <td className="px-6 py-4 text-center text-blue-500 hover:text-blue-700">
          <button
            className="text-blue-500 hover:text-blue-700"
            onClick={() => {
              toggleLocationPop(order.orderId);
            }}
          >
            مشاركة العنوان
          </button>
          {expandLocationPop === order.orderId && (
            <OrderLocationPop order={order} toggleLocationPop={toggleLocationPop} />
          )}
        </td>
        <td className="px-6 py-4 text-center text-blue-500 hover:text-blue-700">
          <Link
            to={`${process.env.PUBLIC_URL}/orders/${order.orderId}`}
            state={order}
            target="_blank"
          >
            طباعة الطلب
          </Link>
        </td>
        <td className="px-6 py-4 text-center text-gray-900">{order.totalIraqiprice}</td>
        <td className="px-6 py-4 text-center text-gray-900">{order.totalCount}</td>

        <td className="px-6 py-4 text-center text-gray-900">
          <button
            className="text-blue-700 font-medium rounded-lg text-sm px-1 py-2.5 text-center"
            onClick={() => toggleExpandPop(order.orderId)}
          >
            تغيير الحالة /
          </button>

          {status === 1 ? "طلب جديد" : status === 2 ? "قيد التنفيذ" : "تم الإنتهاء منه"}
          {expandPopOrderId === order.orderId && (
            <OrderRowPop order={order} setStatus={setStatus} togglePop={toggleExpandPop} />
          )}
        </td>

        <td className="px-6 py-4 text-center text-gray-900">{formatDate(order.orderdate)}</td>
        <th className="px-6 py-4 text-center text-gray-900">{order.regionNameAr}</th>
        <th className="px-6 py-4 text-center text-gray-900">{order.phone}</th>

        <th className="px-6 py-4 text-center text-gray-900">{order.name}</th>
      </tr>
      {expandedOrderId === order.orderId && <OrderExpandRow order={order} />}
    </>
  );
};

export default OrderRow;
